import React from 'react';
import './header.css';
import HeaderSearchBar from './headers/searchBar/HeaderSearchBar';
import HeaderIcons from './headers/menuIcons/HeaderIcons';

function Header() {



  return (
    <header className="header">
      {/* Barre de recherche */}
      <HeaderSearchBar />

      {/* Icônes du header */}
      <HeaderIcons />
    </header>
  )
}

export default Header